angular.module('impactx.rfx').controller('RFXEditItemCtrl', [
    'TranslationService',
    '$mdDialog',
    'RFXBuyerService',
    RFXEditItemController
]);

function RFXEditItemController(TranslationService, $mdDialog, RFXBuyerService) {
    var self = this;
    self.itemCopy = angular.copy(self.item, self.itemCopy);
    self.trns.save = TranslationService.get('save');
    self.trns.abort = TranslationService.get('abort');
    activate();

    self.save = function () {
        self.itemCopy.id = self.itemCopy.id || 0;
        if(self.item.isFreeForm)
            self.itemCopy.isFreeForm = self.item.isFreeForm;
        $mdDialog.hide(self.itemCopy);
    };

    self.abort = function () {
        $mdDialog.cancel();
    };

    function activate() {
        var itemId = impactX.isDefined(self, 'item.id');
        if (!itemId && itemId !== 0) {
            RFXBuyerService.getItemData(self.rfqhId, 0).then(function (item) {
                self.itemCopy = item;
            });
        }
    }
}